import React, { useState, useMemo } from "react";
import {
  validateSimulationName,
  SIMULATION_NAME_MAX_LENGTH,
} from "../../utils/simulationName";
import "../../../devices/components/DeleteDevice.css";

const EditSimulationNameModal = ({
  open,
  simulation,
  onSave,
  onClose,
  loading = false,
}) => {
  const initialValue = simulation?.simulationName || "";
  const [value, setValue] = useState(initialValue);

  const { trimmed, error } = useMemo(() => validateSimulationName(value), [value]);

  const unchanged = trimmed === (initialValue || "").trim();
  const saveDisabled = loading || !!error || unchanged;

  // Reset local state when the modal opens for a different simulation.
  const [prevSim, setPrevSim] = useState(simulation);
  if (simulation !== prevSim) {
    setPrevSim(simulation);
    setValue(simulation?.simulationName || "");
  }

  if (!open || !simulation) return null;

  return (
    <>
      <div
        className="delete-device-overlay"
        onClick={loading ? undefined : onClose}
      />
      <div
        className="delete-device-popup-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-sim-name-title"
      >
        <div className="delete-device-header-container">
          <h3 className="delete-device-title" id="edit-sim-name-title">
            Edit simulation name
          </h3>
          <button
            className="delete-device-close-button"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className="delete-device-content-container">
          <label
            htmlFor="sim-name-input"
            style={{ display: "block", marginBottom: 4, fontWeight: 500 }}
          >
            Simulation name
          </label>
          <input
            id="sim-name-input"
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !saveDisabled) {
                e.preventDefault();
                onSave(trimmed);
              }
            }}
            disabled={loading}
            maxLength={SIMULATION_NAME_MAX_LENGTH + 10}
            autoFocus
            style={{
              width: "100%",
              padding: "8px 10px",
              fontSize: 14,
              border: error ? "1px solid #ef4444" : "1px solid #cbd5e1",
              borderRadius: 6,
              outline: "none",
              boxSizing: "border-box",
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 4,
              fontSize: 12,
            }}
          >
            <span style={{ color: error ? "#ef4444" : "#64748b" }}>
              {error ||
                "Up to 200 characters, printable ASCII only. Leave blank to clear."}
            </span>
            <span style={{ color: trimmed.length > SIMULATION_NAME_MAX_LENGTH ? "#ef4444" : "#94a3b8" }}>
              {trimmed.length} / {SIMULATION_NAME_MAX_LENGTH}
            </span>
          </div>
        </div>

        <div className="delete-device-form-actions">
          <button
            className="delete-device-cancel-action"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="delete-device-delete-button"
            onClick={() => onSave(trimmed)}
            disabled={saveDisabled}
            style={{ backgroundColor: saveDisabled ? undefined : "#2563eb" }}
          >
            {loading ? (
              <>
                <span className="spinner-small" /> Saving&hellip;
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default EditSimulationNameModal;
